import {UserStore} from "./data/stores/UserStore";
import {TenantApi} from "./services/api/base/TenantApi";
import {LoadingPresenter} from "./components/loading/loadingPresenter";
import {TenantProfileApi} from "./services/api/base/TenantProfileApi";
import {TenantProfileStore} from "./data/stores/TenantProfileStore";
import {BookingStore} from "./data/stores/BookingStore";
import {BookingApi} from "./services/api/base/BookingApi";
import {TopBarPresenter} from "./components/topBar/topBarPresenter";
import {setComponentRegistry} from "@/rawdogjs/src/core/Registry";
import {RenderComponent} from "@/rawdogjs/src/renderRoute";
import {Router} from "@/rawdogjs/src/router";
import {DependencyContainerFactory} from "@/rawdogjs/src/dependencyContainerFactory";
import {RegisterDependencies} from "./RegisterDependencies";
import './css/main.css';
import {Routes} from "@/Routes";

const viewModules = require.context('./components', true, /\.ts$/);
const presenterModules = require.context('./components', true, /\.ts$/);
const htmlModules = require.context('./components', true, /\.html$/);

function getLastSegment(path: string): string {
    const parts = path.split('/');
    return parts[parts.length - 1];
}

function capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

setComponentRegistry({
    getView: async (path) => {
        const mod = await import(`./components/${path}.ts`);
        const className = `${capitalize(getLastSegment(path))}`;
        return mod[className];
    },
    getPresenter: async (path) => {
        const mod = await import(`./components/${path}.ts`);
        const className = `${capitalize(getLastSegment(path))}`;
        return mod[className];
    },
    getTemplate: async (path) => {

        try {
            const fragmentPath = `./${path}`;
            const url = htmlModules(fragmentPath);

            const response = await fetch(url);
            return await response.text();
        } catch (error) {
            console.error('Error loading fragment:', error);
        }

    }
});


const router = new Router();
const renderComponent = new RenderComponent(router);
const loading = await renderComponent.render<LoadingPresenter>('loading');

document.body.append(loading._view.$element);

loading.setTitle("Loading...")
loading.setBody("Hello beautiful.")
loading.show(true);

try {

    const container =
        DependencyContainerFactory.create(router);

    const env = process.env;
    
    RegisterDependencies.register(env.API_URL, env, container, router);

    const userStore = container.resolve<UserStore>('UserStore');
    const bookingStore = container.resolve<BookingStore>('BookingStore');
    const bookingApi = container.resolve<BookingApi>('BookingApi');
    const tenantApi = container.resolve<TenantApi>('TenantApi');
    const tenantProfileApi = container.resolve<TenantProfileApi>('TenantProfileApi');
    const tenantProfileStore = container.resolve<TenantProfileStore>('TenantProfileStore');

    await userStore.fetch(tenantApi);

    await tenantProfileStore.fetch(
        tenantProfileApi,
        userStore.getTenantProfileId(),
        userStore.getParentTenant()
    );

    // await bookingStore.fetch(
    //     bookingApi, 
    //     tenantProfileStore.getTenantProfile()?.currentWorkingBookingId,
    //     userStore.getParentTenant()
    // );

    // (window as any).userStore = userStore;
    // (window as any).bookingStore = bookingStore;
    // (window as any).tenantProfileStore = tenantProfileStore;

} catch (error) {

    // forward to login page, unless we are trying to sign up
    console.log(error);

    const currentPath = router.currentPath();

    if (
        // currentPath !== '/' &&
        // currentPath !== '/home' &&
        currentPath !== '/signUp' && 
        currentPath !== '/login' && 
        currentPath !== '/drywallio/capture-email' && 
        currentPath !== '/drywallio/home' &&
        currentPath !== '/drywallio/cleaning-calculator') {

        // global app handler for unauthorized requests (401)
        // 401 outside of this won't be forwarded automatically
        if (error.response && error.response.status === 401) {
            router.navigate("/#/login");
        }

    }

} finally {
    loading.show(false);
}


// make the element a 'nav' element to line up with css
const topBarComponent = await renderComponent.render<TopBarPresenter>('topBar', 'nav');
document.querySelector('#header').append(topBarComponent._view.$element);
await topBarComponent.initialize();

let activeComponent: any;

const updateAppView = async (component: any) => {
    activeComponent = null;
    activeComponent = component;
    document.getElementById('app').innerHTML = '';
    document.getElementById('app').append(activeComponent._view.$element);
    await component.initialize();
}

Routes.register(router, updateAppView, renderComponent);

// router.on(
//     "/login",
//     async () => {
//         await updateAppView(await renderComponent.render("login"));
//     }
// );
//
// router.on(
//     "/home",
//     async () => {
//         await updateAppView(await renderComponent.render("/drywallio/homeMenu"));
//     }
// );
//
// router.on(
//     "/",
//     async () => {
//         await updateAppView(await renderComponent.render("/drywallio/homeMenu"));
//     }
// );
//
// router.on(
//     "/drywallio/hello-world",
//     async () => {
//         await updateAppView(await renderComponent.render("/drywallio/helloWorld"));
//     }
// );
//
//
// router.on(
//     "/drywallio/home",
//     async () => {
//         await updateAppView(await renderComponent.render("/drywallio/homeMenu"));
//     }
// );
//
// router.on(
//     "/resetPassword",
//     async () => {
//         await updateAppView(await renderComponent.render("resetPassword"));
//     }
// );
//
//
// router.on(
//     "/signUp",
//     async () => {
//         await updateAppView(await renderComponent.render("signUp"));
//     }
// );
//
// router.on(
//     "/drywallio/capture-email",
//     async () => {
//         await updateAppView(await renderComponent.render("drywallio/captureEmail"));
//     }
// );
//
// router.on(
//     "/drywallio/schedule-date",
//     async () => {
//         await updateAppView(await renderComponent.render("drywallio/scheduleDate"));
//     }
// );
//
// router.on(
//     "/drywallio/schedule-time",
//     async () => {
//         await updateAppView(await renderComponent.render("drywallio/scheduleTime"));
//     }
// );
//
//
// router.on(
//     "/drywallio/add-address",
//     async () => {
//         await updateAppView(await renderComponent.render("drywallio/addAddress"));
//     }
// );
//
//
// router.on(
//     "/drywallio/contact",
//     async () => {
//         await updateAppView(await renderComponent.render("drywallio/contactStep"));
//     }
// );
//
// router.on(
//     "/drywallio/booking-confirmation",
//     async () => {
//         await updateAppView(await renderComponent.render("drywallio/bookingConfirmation"));
//     }
// );
//
//
// router.on(
//     "/drywallio/create-dating-profile",
//     async () => {
//         await updateAppView(await renderComponent.render("drywallio/createDatingProfile"));
//     }
// );
//
// router.on(
//     "/drywallio/cleaning-calculator",
//     async () => {
//         await updateAppView(await renderComponent.render("drywallio/cleaningCalculator"));
//     }
// );
//
// router.resolve(); // initial load






